import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getChildCategories } from './childCategorySlice';
import { deleteCategory, changeActiveStatus } from '../Category/categorySlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
// import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
// import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
import CommonButton from '../../components/commonButton';
import { Add01Icon } from '../../assets/icons';


const CategoryList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { childCategories } = useSelector((state) => state.childCategories);
  // console.log("childCategories", childCategories);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(childCategories?.total_records / limit);
  const total = childCategories?.total_records || 0;

  const location = useLocation();
  const params = new URLSearchParams(location.search) || 1;
  const initialPage = parseInt(params.get("page") || "1");
  const [currentPage, setCurrentPage] = useState(initialPage);
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_parent_category_id = pathSegments.length > 3 && pathSegments[2] === "child-categories" 
    ? pathSegments[3] 
    : null;
  const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
    ? pathSegments[1] 
    : null;

  const token = localStorage.getItem('admin-auth-token');

  let categoryMessage = localStorage.getItem('child_category_notify_message');

  const categoryStack = JSON.parse(localStorage.getItem("category_id_stack") || "[]");

  const currentCategoryId = pathSegments[3];
  const currentCategoryName = JSON.parse(localStorage.getItem("admin-category-data") || "{}")?.category_name;

  // Only push if not already at the top of stack
  const lastStackItem = categoryStack[categoryStack.length - 1];
  if (!lastStackItem || lastStackItem.id !== currentCategoryId) {
    categoryStack.push({
      id: currentCategoryId,
      name: currentCategoryName || "Untitled",
    });
  }

  localStorage.setItem("category_id_stack", JSON.stringify(categoryStack));

    useEffect(() => {
      if (categoryMessage) {
        setSnackbarMessage(categoryMessage);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        localStorage.removeItem('child_category_notify_message');
      }
    }, [categoryMessage])

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token,
        parent_category_id : selected_parent_category_id,
        organization_id: selected_organization_id
      };
  
      try {
  // console.log("token", token);
  // console.log("selected_parent_category_id", selected_parent_category_id);
  // console.log("selected_organization_id", selected_organization_id);

        if (token && selected_parent_category_id && selected_organization_id) {
          await dispatch(getChildCategories({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCategories();
  }, [dispatch, token, currentPage, searchTerm, setLoading, selected_parent_category_id, selected_organization_id]);


  const columns = [
    // { label: 'ID', key: 'id' },
    {label: 'Image', key: 'category_image', type: 'image' },
    // { label: "Name 2", key: "subcategoriesinfo", type: "custom" },
    { label: 'Name', key: 'category_name' },
    {
      label: "Child Categories",
      key: "subcategoriesinfo",
      type: "custom",
      render: (row) => (
        <span
          className="text-primary cursor-pointer"
          onClick={() => {
              navigate(`/organization/${selected_organization_id}/child-categories/${row.id}?page=1`);
            }}
        >
          {/* View ({row.child_category_count}) */}
        </span>
      )
    },
    // { label: 'Parent Category', key: 'parent_category.category_name' },
    // {label: 'Banner Image', key: 'category_banner_image', type: 'image' },
    { label: "Product Count", key: "productsinfo", type: "custom" },
    {label: 'Attribute Count', key: 'attribute_groups_count'},
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/organization/${selected_organization_id}/child-categories/${selected_parent_category_id}?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedCategoryId) {
      await dispatch(deleteCategory(selectedCategoryId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token,
            parent_category_id : selected_parent_category_id,
            organization_id: selected_organization_id
          };
          dispatch(getChildCategories({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedCategoryId(row.id);
    navigate(`/organization/${selected_organization_id}/child-category-edit/${row.id}?page=${currentPage}`);
    // handleOpen();

  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedCategoryId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedCategoryId(row.id);
};

  const handleStatusChange = async (row) => {
    setSelectedCategoryId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedCategoryId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token,
          parent_category_id : selected_parent_category_id,
          organization_id: selected_organization_id
        };
        dispatch(getChildCategories({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }
  
  useEffect(() => {
      if (initialPage) {
        setCurrentPage(initialPage);
      }     
  }, [initialPage])

  return (
    <>
      <Container fluid className="px-0">

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this category?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Body><span className='text-danger'>Warning:- Deactivating category may impact on website.</span></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Category"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
              navigate(`/organization/${selected_organization_id}/child-categories/${selected_parent_category_id}?page=1`);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Child Category"
            className="btn-primary common-one-shadow"
            onClick={() => {
              // setShowModal(true);
              navigate(`/organization/${selected_organization_id}/child-category-add/${selected_parent_category_id}?page=${currentPage}`);
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={childCategories?.data || []}
              url={childCategories?.url || []}
              showActions={true}
              moduleName="category"
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Categories
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default CategoryList;
